/*
  Gate di consenso per la live chat Gorgias (issue #444) — FAIL-CLOSED.

  Pattern: assets/kiwi-sizing-consent.js (#170/#171, gate KiwiSizing), con
  una differenza voluta: KiwiSizing è fail-OPEN (guida taglie = funzionale),
  qui invece se il consenso NON è determinabile (API Customer Privacy assente,
  in errore, o decisione del visitatore ancora in sospeso) lo script Gorgias
  NON viene caricato: rifiuto = nessuna richiesta ai domini Gorgias per
  costruzione (config.gorgias.chat, assets.gorgias.chat, config.gorgias.io,
  us-east1-898b.gorgias.chat, storage.googleapis.com — elenco ufficiale
  «Add Gorgias Chat domains to your allowlist», docs.gorgias.com 2254024).

  Come funziona:
  - legge dal proprio tag <script> gli attributi
      data-gorgias-application-id  → applicationId (v2, numerico), codice del
                                     bundle-loader v3, oppure URL completa
                                     dello snippet di installazione manuale
      data-gorgias-consent         → "marketing" (default, il più restrittivo,
                                     finché Manuel non classifica il widget)
                                     oppure "preferences" (funzionale)
  - chiede all'API Customer Privacy di Shopify (window.Shopify.customerPrivacy)
    se il trattamento scelto è consentito: marketingAllowed() /
    preferencesProcessingAllowed() rispondono true sia con consenso dato sia
    per i visitatori di regioni senza obbligo di banner (doc Shopify);
  - se la decisione è in sospeso (banner ancora aperto) resta in ascolto
    dell'evento visitorConsentCollected e carica al momento dell'accettazione,
    senza ricaricare la pagina;
  - la revoca del consenso dopo il caricamento non scarica il widget già in
    pagina: vale dalla navigazione successiva (comportamento standard dei
    gate lato tema; OneTrust ricarica comunque la pagina al salvataggio).

  Cosa carica quando il consenso c'è: lo snippet ufficiale di installazione
  manuale Gorgias (doc 286032 «Customize the chat widget with HTML and
  JavaScript», sezione «On Shopify stores»), con GORGIASCHAT_DISABLE_AUTO_OPEN
  impostato PRIMA del loader (doc 460197: le window variables vanno prima
  dello snippet). Il lanciatore custom è in gorgias-widget.js.

  Prerequisito a pannello: il canale Chat deve essere in «Install manually»
  (mai «Quick install for Shopify», che reinietta il widget da solo su ogni
  pagina saltando questo gate — doc 286032, nota finale).

  Diagnostica: <html data-gorgias-chat="gated|loaded"> — letto dalla prova
  consenso (scripts/prova-consenso-444.mjs).
*/
(function () {
  'use strict';

  var gateScript = document.currentScript || document.querySelector('script[data-gorgias-application-id]');
  if (!gateScript) return;

  var appId = (gateScript.getAttribute('data-gorgias-application-id') || '').trim();
  var mode = (gateScript.getAttribute('data-gorgias-consent') || 'marketing').trim().toLowerCase();
  if (!appId) return;
  if (mode !== 'preferences') mode = 'marketing';

  document.documentElement.setAttribute('data-gorgias-chat', 'gated');

  var isV2 = /^\d+$/.test(appId) || appId.indexOf('applicationId=') > -1;

  function loaderSrc(id) {
    if (id.indexOf('://') > -1) return id; // URL completa dello snippet Gorgias
    if (/^\d+$/.test(id)) {
      return 'https://config.gorgias.chat/gorgias-chat-bundle-loader.js?applicationId=' + encodeURIComponent(id);
    }
    return 'https://config.gorgias.chat/bundle-loader/' + encodeURIComponent(id);
  }

  var loaded = false;

  function loadGorgias() {
    if (loaded) return;
    loaded = true;
    // Niente auto-apertura per i visitatori di ritorno (scelta luxury, #291):
    // va impostato PRIMA che il loader parta (doc 460197).
    window.GORGIASCHAT_DISABLE_AUTO_OPEN = true;
    var el = document.createElement('script');
    el.id = isV2 ? 'gorgias-chat-widget-install-v2' : 'gorgias-chat-widget-install-v3';
    el.async = true;
    el.src = loaderSrc(appId);
    document.body.appendChild(el);
    document.documentElement.setAttribute('data-gorgias-chat', 'loaded');
  }

  function allowedFromApi(api) {
    return mode === 'preferences' ? api.preferencesProcessingAllowed() : api.marketingAllowed();
  }

  function allowedFromEvent(detail) {
    return mode === 'preferences' ? detail.preferencesAllowed === true : detail.marketingAllowed === true;
  }

  // Accettazione dal banner dopo il caricamento della pagina: la chat compare
  // senza ricaricare. Un rifiuto non fa nulla (non c'era nulla da togliere).
  document.addEventListener('visitorConsentCollected', function (event) {
    var detail = event && event.detail;
    if (detail && allowedFromEvent(detail)) loadGorgias();
  });

  function evaluate(api) {
    try {
      if (allowedFromApi(api)) loadGorgias();
      // Altrimenti: rifiuto esplicito → niente chat; decisione in sospeso →
      // si attende visitorConsentCollected. In entrambi i casi zero richieste.
    } catch (e) {
      // FAIL-CLOSED: errore dell'API = consenso non determinabile = niente chat.
    }
  }

  function apiUsable(api) {
    return !!api &&
      typeof api.marketingAllowed === 'function' &&
      typeof api.preferencesProcessingAllowed === 'function';
  }

  var api = window.Shopify && window.Shopify.customerPrivacy;
  if (apiUsable(api)) {
    evaluate(api);
  } else if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
    window.Shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      function (error) {
        var loadedApi = window.Shopify && window.Shopify.customerPrivacy;
        if (error || !apiUsable(loadedApi)) return; // FAIL-CLOSED: API non disponibile
        evaluate(loadedApi);
      }
    );
  }
  // else: ambiente senza Shopify.loadFeatures → FAIL-CLOSED, nessun caricamento.
})();
